// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"658":"35336d97","971":"bbb9fa45"}[chunkId] + ".css";
};